export default __webpack_public_path__ + "feed/subs.opml";